import { useMediaQuery } from 'react-responsive';

const readVariableFromCss = (variableName: string) =>
    getComputedStyle(document.documentElement).getPropertyValue(variableName);

export const useResponsive = () => {
    const isLargerThanXl = useMediaQuery({
        query: '(min-width: ' + readVariableFromCss('--media-breakpoint-xl') + ')',
    });
    const isLargerThanLg = useMediaQuery({
        query: '(min-width: ' + readVariableFromCss('--media-breakpoint-lg') + ')',
    });
    const isLargerThanMd = useMediaQuery({
        query: '(min-width: ' + readVariableFromCss('--media-breakpoint-md') + ')',
    });
    const isLargerThanXs = useMediaQuery({
        query: '(min-width: ' + readVariableFromCss('--media-breakpoint-xs') + ')',
    });

    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

    return {
        'media-breakpoint-xl': readVariableFromCss('--media-breakpoint-xl'),
        'media-breakpoint-lg': readVariableFromCss('--media-breakpoint-lg'),
        'media-breakpoint-md': readVariableFromCss('--media-breakpoint-md'),
        'media-breakpoint-xs': readVariableFromCss('--media-breakpoint-xs'),
        isLargerThanXl,
        isLargerThanLg,
        isLargerThanMd,
        isLargerThanXs,
        isPortrait,
    };
};
